module.exports = __webpack_public_path__ + "img/no-video.a9269a9e.svg";